import routes from '../../config/routes';

const buildCollectionOverviewUrl = (slug: string) => {
  return `${routes.collection}/${slug}/overview`;
};

export default buildCollectionOverviewUrl;
